import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const SignUpForm = () => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        email: ''
    });
    const [errors, setFormErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setFormErrors({ ...errors, [e.target.name]: '' });
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.username.length < 4) {
            newErrors.username = 'Username must be at least 4 characters';
            valid = false;
        }

        if (formData.password.length < 4) {
            newErrors.password = 'Password must be at least 4 characters';
            valid = false;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData.email)) {
            newErrors.email = 'Invalid email address';
            valid = false;
        }

        setFormErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const response = await axios.post('/api/v1/user/signup', formData);
                console.log('User signed up:', response.data);
                setSuccessMessage('Sign up successful');
            } catch (error) {
                console.error('Error signing up:', error.response.data);
                setFormErrors({ response: 'An error occurred while signing up' });
            }
        }
    };

    return (
        <div>
            <h2>Sign Up</h2>
            <small id="signupHelp" class="form-text text-muted">Once you sign up, an admin will be able to provide you permissions</small>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="username">Username:</label>
                    <input type="text" id="username" name="username" className="form-control" value={formData.username} onChange={handleChange} />
                    {errors.username && <div className="alert alert-danger">{errors.username}</div>}
                </div>
                <div>
                    <label htmlFor="password">Password:</label>
                    <input type="password" id="password" name="password" className="form-control" value={formData.password} onChange={handleChange} />
                    {errors.password && <div className="alert alert-danger">{errors.password}</div>}
                </div>
                <div className="mb-2">
                    <label htmlFor="email">Email:</label>
                    <input type="text" id="email" name="email" className="form-control" value={formData.email} onChange={handleChange} />
                    {errors.email && <div className="alert alert-danger">{errors.email}</div>}
                </div>
                {errors.response && <div className="alert alert-danger">{errors.response}</div>}
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                <button className="btn btn-primary" type="submit">Sign Up</button>
                <div className="mt-2">
                    <small id="signupHelp" class="form-text text-muted">Already have an account? <Link to="/login">Sign in here.</Link></small>
                </div>
            </form>
        </div>
    );
};

export default SignUpForm;